import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { setMainPhotoAction } from 'actions/photo/photoViewerAction'
import { hideTooltipsAction } from 'actions/tooltipAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { Colors } from 'common-constants/colors'
import { ProfileRouteParams } from 'components/paths'
import { ButtonLink } from 'components/presentational/link'
import {
  TooltipDefaultContent,
  TooltipDefaultContentItem,
} from 'components/presentational/Tooltip'
import { photoDeleteConfirmation } from 'components/uninotice/uniNoticeIdList'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

const DeletePhoto = () => {
  return (
    <ButtonLink $linkColor={Colors.warning} $linkHoverColor={Colors.warning}>
      <FormattedMessage id="photo.remove" defaultMessage="Удалить фото" />
    </ButtonLink>
  )
}

interface MenuCurrentUserProps {
  selectedPhotoIndex: number
}

export const MenuCurrentUser: FC<MenuCurrentUserProps> = ({
  selectedPhotoIndex,
}) => {
  const dispatch = useDispatch()
  const { userId } = useParams<ProfileRouteParams>()
  const { photos } = useShallowEqualSelector(
    ({ photoViewerReducer: { photos } }) => ({
      photos,
    })
  )
  const handleSetMainPhoto = () => {
    dispatch(setMainPhotoAction(Number(photoId)))
    dispatch(hideTooltipsAction())
  }

  const { photoId, main, portrait } = photos[selectedPhotoIndex]

  const handleDeletePhoto = () => {
    dispatch(
      fetchUniNoticeAction(photoDeleteConfirmation, {
        photos: { userId: [userId], photosIds: [photoId] },
      })
    )
    dispatch(hideTooltipsAction())
  }

  // пункт 'сделать главной' - показываем только главные и портретные
  if (!main && portrait) {
    return (
      <TooltipDefaultContent>
        <TooltipDefaultContentItem onClick={handleSetMainPhoto}>
          <ButtonLink>
            <FormattedMessage id="photoviewer.photo_menu.set_main_photo" />
          </ButtonLink>
        </TooltipDefaultContentItem>
        <TooltipDefaultContentItem onClick={handleDeletePhoto}>
          <DeletePhoto />
        </TooltipDefaultContentItem>
      </TooltipDefaultContent>
    )
  }

  return (
    <TooltipDefaultContent>
      <TooltipDefaultContentItem onClick={handleDeletePhoto}>
        <DeletePhoto />
      </TooltipDefaultContentItem>
    </TooltipDefaultContent>
  )
}
